import React from "react";

function LogoFinal(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} width="307" height="186" viewBox="0 0 307 186" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M200 3L3 181L82.0456 161.998L200 3Z" fill="black"/>
            <path d="M73 0L0 176L52.1601 124.719L73 0Z" fill="black"/>
            <path d="M96 153L257 44L149.904 83.4306L96 153Z" fill="black"/>
            <path d="M83.6873 169L11 186H307L83.6873 169Z" fill="black"/>
            <path d="M102 158L290 118.46L170.839 114L102 158Z" fill="black"/>
            <path d="M57.8106 6.50945C54.2619 8.77676 51.9762 12.5078 51.61 16.6309L49 46L68 0L57.8106 6.50945Z"
                  fill="black"/>
            <path d="M104 163.505L296 177L185.441 149L104 163.505Z" fill="black"/>
        </svg>
    )
}

export default LogoFinal;